<script setup lang="ts">
import CardComponent from "@/views/Calculators/DestinyMatrix/components/CardComponent.vue";
import CircleComponent from "@/views/Calculators/DestinyMatrix/components/CircleComponent.vue";
import SummarizeComponent from "@/views/Calculators/DestinyMatrix/components/SummarizeComponent.vue";
import { useI18n } from "vue-i18n";
import { defineProps } from "vue";
import { DestinyMatrix } from "@/types/destinyMatrix";

defineProps<{
  matrix: DestinyMatrix | undefined;
}>();

const { t } = useI18n();
</script>

<template>
  <CardComponent>
    <template #content>
      <div class="flex flex-col text-left">
        <div class="content-row">
          <p class="flex-1 font-bold text-base lg:text-lg">
            {{
              t(
                "calculators.destiny-matrix.personal-card.yourself-search-title"
              )
            }}
          </p>
          <p class="flex-1 font-bold text-base lg:text-lg">
            {{
              t("calculators.destiny-matrix.personal-card.socialisation-title")
            }}
          </p>
        </div>
        <div class="content-row">
          <p class="flex-1 text-xs text-gray-500">
            {{
              t("calculators.destiny-matrix.personal-card.yourself-search-desc")
            }}
          </p>
          <p class="flex-1 text-xs text-gray-500">
            {{
              t("calculators.destiny-matrix.personal-card.socialisation-desc")
            }}
          </p>
        </div>
        <div class="content-row">
          <SummarizeComponent
            class="flex-1"
            :firstLabel="t('calculators.destiny-matrix.personal-card.heaven')"
            :secondLabel="t('calculators.destiny-matrix.personal-card.earth')"
            :firstValue="matrix?.personal.h ?? 0"
            :secondValue="matrix?.personal.e ?? 0"
            :sumValue="matrix?.personal.personal ?? 0"
          />
          <SummarizeComponent
            class="flex-1"
            :firstLabel="t('calculators.destiny-matrix.personal-card.male')"
            :secondLabel="t('calculators.destiny-matrix.personal-card.female')"
            :firstValue="matrix?.personal.m ?? 0"
            :secondValue="matrix?.personal.f ?? 0"
            :sumValue="matrix?.personal.social ?? 0"
          />
        </div>
        <div class="content-row">
          <div class="flex-1 flex gap-2 items-center pt-4 pb-1">
            <p class="font-bold text-base lg:text-lg">
              {{
                t(
                  "calculators.destiny-matrix.personal-card.spirit-harmony-title"
                )
              }}
            </p>
            <CircleComponent :value="matrix?.personal.harmony ?? 0" />
          </div>
          <div class="flex-1 flex gap-2 items-center pt-4 pb-1">
            <p class="font-bold text-base lg:text-lg">
              {{
                t("calculators.destiny-matrix.personal-card.planetary-title")
              }}
            </p>
            <CircleComponent :value="matrix?.personal.planetary ?? 0" />
          </div>
        </div>
        <div class="content-row">
          <p class="flex-1 text-xs text-gray-500">
            {{
              t("calculators.destiny-matrix.personal-card.spirit-harmony-desc")
            }}
          </p>
          <p class="flex-1 text-xs text-gray-500">
            {{ t("calculators.destiny-matrix.personal-card.planetary-desc") }}
          </p>
        </div>
      </div>
    </template>
  </CardComponent>
</template>

<style scoped>
.content-row {
  @apply flex gap-3;
}
</style>
